module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"ไม่สามารถ Load ข้อมูลได้","error.timeout":"พบปัญหาในการ Load ข้อมูล กรุณารอสักครู่แล้ว ทดลองเข้าใหม่"}}')
  delete Component.options._Ctor
}
